import React, { useState, useEffect } from 'react';
import { EllipsisIcon } from '@rsos/assets/icons';
import { CheckBox, Absolute, Box } from '@rsos/components/capstone/base';
import Dropdown from '@rsos/components/capstone/base/Dropdown';
import { DropdownBody } from '@rsos/components/capstone/base/Dropdown/DropdownComponents';
import { formatDateWithLocalTimezone } from '../../../utils/dateUtilities';
import { UserContainer, UserData, EditRole } from '../styles/User.styles';
import { IconWrapper } from '../styles/Users.styles';

const User = ({
  user,
  toggleEditUserModal,
  onCheckBoxChange,
  arrayHelpers,
  values,
}) => {
  const [isDropdownClicked, setIsDropdownClicked] = useState(false);

  const EditUserDropdown = ({ onClick, selected }) => {
    useEffect(() => {
      if (isDropdownClicked !== selected) {
        setIsDropdownClicked(selected);
      }
    }, [selected]);

    const handleOptionsToggle = () => {
      setIsDropdownClicked(prev => !prev);
      onClick();
    };
    return (
      <IconWrapper clickable onClick={handleOptionsToggle}>
        <EllipsisIcon width={16} height={16} color="currentColor" />
      </IconWrapper>
    );
  };
  return (
    <UserContainer data-name={`user-container-${user.email}`}>
      <UserData>
        <CheckBox
          type="checkbox"
          noText
          name={user.id}
          isChecked={!!values.users.find(u => u.email === user.email)}
          onChange={e => onCheckBoxChange(e, arrayHelpers, user, values)}
        />
      </UserData>
      <UserData>
        <Box maxWidth={110} ellipsis>
          {user.first_name} {user.last_name}
        </Box>
      </UserData>
      <UserData>
        <Box ellipsis>{user.email}</Box>
      </UserData>
      <UserData>
        <Box ellipsis>{user.role}</Box>
      </UserData>
      <UserData>
        <Box ellipsis>
          {formatDateWithLocalTimezone(user.last_active_session)}
        </Box>
      </UserData>
      <UserData flexEnd>
        <IconWrapper />
        <Dropdown triggerElement={EditUserDropdown} triggerOnClose>
          {() => (
            <Absolute right={0} zIndex={1}>
              <DropdownBody>
                <EditRole
                  bg="background"
                  onClick={() => toggleEditUserModal(user)}
                >
                  Edit Role
                </EditRole>
              </DropdownBody>
            </Absolute>
          )}
        </Dropdown>
      </UserData>
    </UserContainer>
  );
};

export default User;
